import { atom } from 'jotai';
import store from 'store2';
import { DEFAULT_SETTINGS, SETTINGS_STORAGE_KEY_NAME } from './constants';
import type { Settings } from './types';

export const settingsAtom = atom<Settings>(
  (store.get(SETTINGS_STORAGE_KEY_NAME) as Settings) ?? DEFAULT_SETTINGS,
);
